import { render, staticRenderFns } from "./MentionDetailsView.vue?vue&type=template&id=41dcfc30&"
import script from "./MentionDetailsView.vue?vue&type=script&lang=ts&"
export * from "./MentionDetailsView.vue?vue&type=script&lang=ts&"
import style0 from "./MentionDetailsView.vue?vue&type=style&index=0&id=41dcfc30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports